import styled, { css } from 'styled-components';
import { ANIMATION_CURVE, ANIMATION_DURATION, getSpacingToken, getToken, Sized, Status } from '@optimus-web/common';
import { getColor } from '../common/FormLabel';
import { getBorderColor, getTextColor } from './getFieldStyles';

export const FieldContainer = styled.div`
    text-align: left;
`;

export const FieldHeader = styled.div<Sized & { $disabled?: boolean; readOnly?: boolean }>`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: ${(props) =>
        props.size === 'large' || props.size === 'extraLarge' ? getSpacingToken('100') : getSpacingToken('50')}px;
    color: ${getColor};
`;

export const FieldIconButtonWrapper = styled.div`
    display: flex;
    align-items: center;
`;

export interface InputWrapperProps extends Sized {
    $disabled?: boolean;
    error?: boolean;
    focused?: boolean;
    readOnly?: boolean;
    status?: Status;
}

export const FieldInputWrapper = styled.div<InputWrapperProps>`
    border-width: ${getToken('borderWidth150')}px;
    border-style: solid;
    border-color: ${getBorderColor};
    color: ${getTextColor};
    background: ${({ $disabled }) => ($disabled ? getToken('backgroundDisabled') : getToken('backgroundStaticFlat'))};
    display: flex;
    justify-content: center;
    border-radius: ${getToken('borderRadius100')}px;
    box-sizing: border-box;
    transition-duration: ${ANIMATION_DURATION.default}ms;
    transition-property: border-color;
    transition-timing-function: ${ANIMATION_CURVE.default};

    @media (pointer: fine) {
        &:hover {
            ${({ $disabled, error, focused, readOnly }) =>
                !focused &&
                !$disabled &&
                !error &&
                !readOnly &&
                css`
                    border-color: ${getToken('borderInteractiveSecondaryHover')};
                `}
        }
    }
`;
